import React from 'react';
import * as Styled from './Dashboard.styles';
import Wrapper from '../../components/Wrapper/Wrapper';
import CardContainer from './components/CardsContainer';
import ChartContainer from './components/ChartContainer';

export default function Dashboard() {
  return (
    <Wrapper title="Dashboard">
      <Styled.Container>
        <CardContainer />
        <ChartContainer />
      </Styled.Container>
    </Wrapper>
  );
}
